import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemeMode = "light" | "dark";

interface ThemeState {
  mode: ThemeMode;
  toggle: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: "light",
      toggle: () =>
        set((s) => ({ mode: s.mode === "light" ? "dark" : "light" })),
    }),
    { name: "ledger-theme-mode" },
  ),
);

/**
 * Read the persisted mode from localStorage synchronously.
 * Used in main.tsx to prevent a flash of the wrong theme before React hydrates.
 */
export function getInitialMode(): ThemeMode {
  try {
    const raw = localStorage.getItem("ledger-theme-mode");
    if (raw) {
      const parsed = JSON.parse(raw) as { state?: { mode?: ThemeMode } };
      if (parsed?.state?.mode === "dark") return "dark";
    }
  } catch {
    /* ignore */
  }
  return "light";
}
